import React, { useState } from "react";
import { Upload } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { sendFile } from "services/restAPI/RestApi";
import { Message, Button, Input } from "../../../../BP2Components";
import { useIntl } from "react-intl";

const PictureWebSettings = ({ value }) => {
   const intl = useIntl();
   const dispatch = useDispatch();

   const [settings, setSettings] = useState({
      ...value
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   const overwriteDefaultUploadFunction = ({ file, onSuccess }) => {
      setTimeout(() => {
         onSuccess("ok");
      }, 0);
   };

   const handleSelectFile = (info) => {
      var formData = new FormData();
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
         Message.success(`${info.file.name} ${(<IntlMessages id="forms.uploadSucces" />)}`);

         formData.append("multipartFile", info.file.originFileObj);
         sendFile(formData).then((res) => {
            setSettings({
               ...settings,
               fileId: res.data,
               fileName: info.file.name
            });
         });
      } else if (info.file.status === "error") {
         Message.error(`${info.file.name} ${(<IntlMessages id="forms.uploadFailed" />)}`);
      }
   };
   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="file" className="widget-settings__inner__label">
                     <IntlMessages id="settings.uploadFile" />:
                     <Upload
                        customRequest={overwriteDefaultUploadFunction}
                        onChange={handleSelectFile}
                     >
                        <Button buttonType="primary">
                           {" "}
                           <IntlMessages id="settings.upload" />
                        </Button>
                     </Upload>
                  </label>
                  <label key="fileName" className="widget-settings__inner__label">
                     <IntlMessages id="settings.fileName" />:
                     <Input
                        type="fileName"
                        name="fileName"
                        disabled
                        value={settings.fileName}
                        style={{ width: "400px" }}
                     />
                  </label>
                  <label key="fileId" className="widget-settings__inner__label">
                     <IntlMessages id="settings.fileId" />:
                     <Input
                        type="fileId"
                        name="fileId"
                        disabled
                        value={settings.fileId}
                        style={{ width: "400px" }}
                     />
                  </label>
                  <label key="textString" className="widget-settings__inner__label">
                     <IntlMessages id="settings.textString" />:
                     <Input
                        type="textString"
                        name="textString"
                        defaultValue={value.textString}
                        onChange={handleChange}
                        style={{ width: "400px" }}
                     />
                  </label>
                  <label key="hrefString" className="widget-settings__inner__label">
                     <IntlMessages id="settings.hrefString" />:
                     <Input
                        // type="url"
                        name="hrefString"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.hrefString}
                     />
                  </label>
                  <label key="webKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.webKey" />:
                     <Input
                        // type="url"
                        name="webKey"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.webKey}
                     />
                  </label>{" "}
                  <label key="widgetKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.widgetKey" />:
                     <Input
                        // type="url"
                        name="widgetKey"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.widgetKey}
                     />
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.save" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default PictureWebSettings;
